const DMSReducer = (state = {}, action) => {
    switch (action.type) {
      case "DMS_LISTVIEW":
        return Object.assign({}, state, {
          DMS_ListView: action.data
        });
      case "DMS_ACTIVITY":
        return Object.assign({}, state, {
          DMS_Actvity: action.data
        });
      case "DMS_ADD":
        return Object.assign({}, state, {
          DMS_Add: action.data
        });
      case "DMSEDIT_DOCS":
        return Object.assign({}, state, {
          geteditdms: action.data
        });
  
      case "SHARE_DMSDATAS":
        return Object.assign({}, state, {
          shareddmsdata: action.data
        });
      case "ERROR_DMSDATAS":
        return Object.assign({}, state, {
          errordmspass: action.data
        });
      default:
        return state;
    }
  };
  
  export default DMSReducer;
  
  